<template>
  <div class="login-container">
    <div class="login-background">
      <div class="login_text">大庚科技</div>
      <el-input class="username-text" v-model="inputname">
        <template slot="prepend">用户名</template>
      </el-input>
      <el-input
        show-password
        type="password"
        class="userpassword-text"
        v-model="inputpassword"
      >
        <template slot="prepend">密码</template>
      </el-input>
      <el-button @click="login" class="login-button" type="primary"
        >登录</el-button
      >
      <!-- 添加修改密码链接 -->
      <a
        href="#"
        @click.prevent="goToChangePassword"
        class="change-password-link"
      >
        修改密码
      </a>
    </div>
    <div
      class="modal-overlay"
      v-if="centerDialogVisible"
      @click="handleOverlayClick"
    >
      <div class="modal-container" @click.stop>
        <!-- 弹窗头部 -->
        <div class="modal-header">
          <h3 class="modal-title">手机验证</h3>
          <button class="close-btn" @click="closeModal">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- 弹窗内容 -->
        <div class="modal-body">
          <!-- 手机号输入框 -->
          <div class="form-group">
            <label for="phone" class="form-label">手机号</label>
            <div class="input-wrapper">
              <i class="fas fa-phone input-icon"></i>
              <input
                type="tel"
                id="phone"
                v-model="phone"
                @input="validatePhone"
                placeholder="请输入手机号"
                class="form-input"
                :class="{ 'is-invalid': phoneError }"
                :disabled="centerDialogVisiblephone"
              />
            </div>
            <p class="error-message" v-if="phoneError">{{ phoneError }}</p>
          </div>

          <!-- 验证码输入框和发送按钮 -->
          <div class="form-group">
            <label for="code" class="form-label">验证码</label>
            <div class="input-with-button">
              <div class="input-wrapper">
                <i class="fas fa-shield-alt input-icon"></i>
                <input
                  type="text"
                  id="code"
                  v-model="code"
                  placeholder="请输入验证码"
                  class="form-input"
                />
              </div>
              <button
                class="send-code-btn"
                @click="sendVerificationCode"
                :disabled="!isPhoneValid || isCountingDown"
                :class="{ 'is-disabled': !isPhoneValid || isCountingDown }"
              >
                {{ isCountingDown ? `${countdown}s后重新发送` : "发送验证码" }}
              </button>
            </div>
          </div>
        </div>

        <!-- 弹窗底部 -->
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModal">取消</button>
          <button
            class="confirm-btn"
            @click="handleConfirm"
            :disabled="!isPhoneValid || !code"
            :class="{ 'is-disabled': !isPhoneValid || !code }"
          >
            确认
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fingerprint2 from "fingerprintjs2";
// 引入 crypto-js 库
import CryptoJS from "crypto-js";
// 引入 crypto-js 的 MD5 模块
import MD5 from "crypto-js/md5";
import Utf8 from "crypto-js/enc-utf8";
export default {
  name: "HelloWorld",
  props: {},
  data() {
    return {
      inputname: "",
      inputpassword: "",
      attrJson: "",
      attrUid: "",
      murmurword: "",
      newmurmurword: "",
      lastLoginTime: 0, // 上次点击时间戳（用于时间差判断）
      loginLimitDuration: 2000, // 限流时长（毫秒，如2秒内只能点一次）
      centerDialogVisible: false,
      // 手机号
      phone: "",
      // 验证码
      code: "",
      // 手机号错误信息
      phoneError: "",
      // 手机号是否有效
      isPhoneValid: false,
      // 是否正在倒计时
      isCountingDown: false,
      // 倒计时秒数
      countdown: 60,
      //手机号判断
      centerDialogVisiblephone: true,
      countdownTimer: null, // 存储定时器实例
      salt: "", //盐
    };
  },
  methods: {
    // MD5加盐加密
    encryptPassword(password) {
      try {
        // 1. 与后端逻辑对齐：拼接原始字符串 + 盐值（str + salt）
        const combinedStr = password + this.salt;

        // 2. 按指定字符集（UTF-8）编码为字节流（crypto-js 内部默认用 Utf8 编码，与后端一致）
        const encodedStr = Utf8.parse(combinedStr);

        // 3. 计算 MD5 哈希值（得到 WordArray 类型，需转为十六进制字符串）
        const md5Hash = MD5(encodedStr);

        // 4. 转为 32 位小写十六进制字符串，后端要求大写，所以加 .toUpperCase()
        return md5Hash.toString().toUpperCase();
      } catch (error) {
        console.error("MD5 加盐加密失败：", error);
        return ""; // 与后端异常返回空字符串的逻辑对齐
      }
    },
    goToChangePassword() {
      //修改密码
      this.$router.push({
        path: "/updatapassword",
        query: { attrUid: this.loginattrid, attrname: this.loginname },
      });
    },
    // 验证手机号
    validatePhone() {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!this.phone) {
        this.phoneError = "请输入手机号";
        this.isPhoneValid = false;
      } else if (!phoneReg.test(this.phone)) {
        this.phoneError = "请输入有效的手机号";
        this.isPhoneValid = false;
      } else {
        this.phoneError = "";
        this.isPhoneValid = true;
      }
    },

    // 发送验证码
    sendVerificationCode() {
      if (!this.isPhoneValid) return;
      this.axios({
        url: "/dashbord/base/sendCode",
        method: "GET",
        responseType: "json",
        headers: {
          mac: this.newmurmurword,
          token: localStorage.getItem("token"), // 从localStorage获取token
        },
        params: {
          phone: this.phone,
        },
      })
        .then((res) => {
          const h = this.$createElement;
          console.log(res.data);
          if (res.data.code === 200) {
            this.$notify({
              title: "提示",
              message: h("i", "验证码已发送，请注意查收"),
            });
            // 启动倒计时
            this.startCountdown();
          } else if (res.data.code === 900) {
            this.$notify({
              title: "提示",
              message: h("i", res.data.message),
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 开始倒计时
    startCountdown() {
      // 关键：启动新倒计时前，先清除可能存在的旧定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.isCountingDown = true;
      // 将定时器实例保存到 data 中的 countdownTimer
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer); // 倒计时结束后清除当前定时器
          this.isCountingDown = false;
          this.countdown = 60; // 重置倒计时时间
          this.countdownTimer = null; // 清空定时器实例
        }
      }, 1000);
    },

    // 关闭弹窗
    closeModal() {
      this.centerDialogVisible = false;
      this.resetForm();
    },

    // 点击遮罩层关闭弹窗
    handleOverlayClick() {
      this.closeModal();
    },

    // 处理确认
    handleConfirm() {
      if (!this.isPhoneValid || !this.code) return;
      this.logincode();
    },
    // 登录
    logincode() {
      //判断localStorage中是否存在token
      this.newmurmurword = this.murmurword + this.inputname;
      const token = localStorage.getItem("token");
      if (token !== null) {
        // 判断token是否为空字符串
        if (token !== "") {
          this.loginnormally();
        } else {
          // token为空弹窗提示
          this.$confirm("当前设备没有登录记录，请选择登陆类型。", "提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: "临时设备",
            cancelButtonText: "受信任设备",
            type: "warning",
          })
            .then(() => {
              this.temporarylogin();
            })
            .catch((action) => {
              if (action === "close") {
                this.$message({
                  type: "info",
                  message: "已取消选择",
                });
              } else if (action === "cancel") {
                // 查询是否绑定过超过两个mac
                this.selmac();
              }
            });
        }
      } else {
        // token不存在弹窗提示
        this.$confirm("当前设备没有登录记录，请选择登陆类型。", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "临时设备",
          cancelButtonText: "受信任设备",
          type: "warning",
        })
          .then(() => {
            this.temporarylogin();
          })
          .catch((action) => {
            if (action === "close") {
              this.$message({
                type: "info",
                message: "已取消选择",
              });
            } else if (action === "cancel") {
              // 查询是否绑定过超过两个mac
              this.selmac();
            }
          });
      }
    },
    // 重置表单
    resetForm() {
      this.phone = "";
      this.code = "";
      this.phoneError = "";
      this.isPhoneValid = false;
      // 清除倒计时：如果有活跃的定时器，立即销毁
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null; // 清空实例
      }
      // 重置倒计时状态
      this.isCountingDown = false;
      this.countdown = 60;
    },
    // 登录发送验证码
    login() {
      // 1. 先判断是否在限流时间内
      const currentTime = Date.now(); // 当前时间戳
      if (currentTime - this.lastLoginTime < this.loginLimitDuration) {
        return; // 触发限流，直接返回
      }
      this.lastLoginTime = currentTime; // 记录本次点击时间
      // 判断名字是否输入为空
      if (this.inputname !== "") {
        // 判断密码是否输入为空
        if (this.inputpassword !== "") {
          this.newmurmurword = this.murmurword + this.inputname;
          //查询是否绑定手机号
          this.axios({
            url: "/Management/selStaffInfo",
            method: "GET",
            responseType: "json",
            headers: {
              mac: this.newmurmurword,
            },
            params: {
              // 使用md5加密账号
              account: this.inputname,
              // 使用md5加密密码
              password: this.encryptPassword(this.inputpassword),
            },
          })
            .then((res) => {
              if (res.data.code === 200) {
                if (res.data.data.isUpdate === "1") {
                  this.$router.push({
                    path: "/updatapassword",
                    query: {
                      attrname: this.inputname,
                    },
                  });
                } else {
                  if (res.data.data.phone !==null) {
                    this.phone = res.data.data.phone;
                    this.centerDialogVisiblephone = true;
                    this.centerDialogVisible = true;
                    this.validatePhone();
                  } else {
                    this.centerDialogVisiblephone = false;
                    this.centerDialogVisible = true;
                  }
                }
              } else if (res.data.code === 900) {
                this.open3(res.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.open2();
        }
      } else {
        this.open1();
      }
    },
    open1() {
      const h = this.$createElement;
      this.$notify({
        title: "提示",
        message: h("i", "请输入用户名"),
      });
    },
    open2() {
      const h = this.$createElement;
      this.$notify({
        title: "提示",
        message: h("i", "请输入密码"),
      });
    },
    open3(message) {
      const h = this.$createElement;
      this.$notify({
        title: "错误",
        message: h("i", message),
      });
    },
    // 浏览器指纹
    createFingerprint() {
      Fingerprint2.get((components) => {
        const values = components.map((component) => component.value);
        const murmur = Fingerprint2.x64hash128(values.join(""), 31);
        this.murmurword = murmur;
        console.log(this.murmurword);
      });
    },
    // 临时登录
    temporarylogin() {
      this.axios({
        url: "/Management/dataLogin",
        method: "GET",
        responseType: "json",
        headers: {
          mac: this.newmurmurword,
          token: "",
        },
        params: {
          // 使用md5加密账号
          account: this.inputname,
          // 使用md5加密密码
          password: this.encryptPassword(this.inputpassword),
          flag: "temporary",
          code: this.code,
          phone: this.phone,
        },
      })
        .then((res) => {
          console.log(res.data);
          if (res.data.code === 200) {
            // 使用localStorage存储数据（7天有效期需手动处理，这里仅存储）
            localStorage.setItem("fileInfoId", res.data.data.attrUid);
            localStorage.setItem("fileInfoIdname", this.inputname);
            localStorage.setItem("companyType", res.data.data.companyType);
            localStorage.setItem("longintype", res.data.data.type);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("mac", this.newmurmurword);
            localStorage.setItem("id", res.data.data.id);
            this.attrJson = res.data.data.account;
            this.attrUi = res.data.data.attrUi;
            this.resetForm();
            this.centerDialogVisible = false;
            this.$router.push({
              path: "/quarysaler",
              query: {
                attrUid: res.data.data.attrUid,
                attrname: this.inputname,
                companyType: res.data.data.companyType,
                longintype: res.data.data.type,
              },
            });
          } else if (res.data.code === 900) {
            this.open3(res.data.message);
            this.centerDialogVisible = true;
            // this.resetForm();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 永久登录
    permanentlogin() {
      this.axios({
        url: "/Management/dataLogin",
        method: "GET",
        responseType: "json",
        headers: {
          mac: this.newmurmurword,
          token: "",
        },
        params: {
          // 使用md5加密账号
          account: this.inputname,
          // 使用md5加密密码
          password: this.encryptPassword(this.inputpassword),
          flag: "trusted",
          code: this.code,
          phone: this.phone,
        },
      })
        .then((res) => {
          console.log(res.data);
          if (res.data.code === 200) {
            // 存储到localStorage
            localStorage.setItem("fileInfoId", res.data.data.attrUid);
            localStorage.setItem("fileInfoIdname", this.inputname);
            localStorage.setItem("companyType", res.data.data.companyType);
            localStorage.setItem("longintype", res.data.data.type);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("mac", this.newmurmurword);
            localStorage.setItem("id", res.data.data.id);
            this.attrJson = res.data.data.account;
            this.attrUi = res.data.data.attrUi;
            this.resetForm();
            this.centerDialogVisible = false;
            this.$router.push({
              path: "/quarysaler",
              query: {
                attrUid: res.data.data.attrUid,
                attrname: this.inputname,
                companyType: res.data.data.companyType,
                longintype: res.data.data.type,
              },
            });
          } else if (res.data.code === 900) {
            this.open3(res.data.message);
            this.centerDialogVisible = true;
            // this.resetForm();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 正常登录
    loginnormally() {
      this.axios({
        url: "/Management/dataLogin",
        method: "GET",
        responseType: "json",
        headers: {
          mac: this.newmurmurword,
          token: localStorage.getItem("token"), // 从localStorage获取token
        },
        params: {
          // 使用md5加密账号
          account: this.inputname,
          // 使用md5加密密码
          password: this.encryptPassword(this.inputpassword),
          flag: "temporary",
          code: this.code,
          phone: this.phone,
        },
      })
        .then((res) => {
          console.log(res.data);
          if (res.data.code === 200) {
            // 更新localStorage数据
            localStorage.setItem("fileInfoId", res.data.data.attrUid);
            localStorage.setItem("fileInfoIdname", this.inputname);
            localStorage.setItem("companyType", res.data.data.companyType);
            localStorage.setItem("longintype", res.data.data.type);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("mac", this.newmurmurword);
            localStorage.setItem("id", res.data.data.id);
            this.attrJson = res.data.data.account;
            this.attrUi = res.data.data.attrUi;
            this.resetForm();
            this.centerDialogVisible = false;
            this.$router.push({
              path: "/quarysaler",
              query: {
                attrUid: res.data.data.attrUid,
                attrname: this.inputname,
                companyType: res.data.data.companyType,
                longintype: res.data.data.type,
              },
            });
          } else if (res.data.code === 900) {
            this.open3(res.data.message);
            this.centerDialogVisible = true;
            // this.resetForm();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查询是否绑定过超过两个mac
    selmac() {
      this.axios({
        url: "/Management/findAccountMac",
        method: "GET",
        responseType: "json",
        headers: {
          mac: this.newmurmurword,
        },
        params: {
          // 使用md5加密账号
          account: this.inputname,
        },
      })
        .then((res) => {
          console.log(res.data);
          if (res.data.code === 200) {
            // 没超过两台
            if (res.data.data.status === "no") {
              this.permanentlogin();
            } else {
              // 超过两台弹窗提示
              this.$confirm("受信任设备最多为两台是否继续", "提示", {
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.permanentlogin();
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.createFingerprint();
    // 检查localStorage中是否有保存的用户名信息
    const userName = localStorage.getItem("fileInfoIdname");
    if (userName && userName !== "") {
      this.$router.push({
        path: "/quarysaler",
        query: {
          attrUid: localStorage.getItem("fileInfoId"),
          attrname: userName,
          companyType: localStorage.getItem("companyType"),
          longintype: localStorage.getItem("longintype"),
        },
      });
    }
    //获取md5盐
    this.axios({
      url: "/dashbord/base/selSalt",
      method: "GET",
      responseType: "json",
    })
      .then((res) => {
        console.log(res.data);
        if (res.data.code === 200) {
          this.salt = res.data.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style scoped>
.login-container {
  height: 100%;
  width: 100%;
  background-image: url("http://dgoss.91dageng.com.cn/img/01d7c25625ff866ac7254878909a5b.png%401280w_1l_2o_100sh.png");
  background-size: 100%;
  position: fixed;
  min-width: 1200px;
  overflow: auto;
}
.login-background {
  text-align: center;
  background-color: #fff;
  border-radius: 5px;
  width: 400px;
  height: 450px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.login_text {
  margin-top: 30px;
}
.username-text {
  margin-top: 50px;
  margin-left: 20px;
  margin-right: 20px;
  width: 250px;
}
.userpassword-text {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  width: 250px;
}
.login-button {
  width: 250px;
  margin-top: 70px;
  margin-left: 20px;
  margin-right: 20px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-container {
  width: 90%;
  max-width: 400px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: slideIn 0.3s ease;
}

.modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  padding: 4px;
  border-radius: 50%;
}

.close-btn:hover {
  color: #333;
  background-color: #f5f5f5;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #999;
  font-size: 16px;
}

.form-input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #42b983;
  box-shadow: 0 0 0 3px rgba(66, 185, 131, 0.1);
}

.form-input.is-invalid {
  border-color: #ff4d4f;
}

.error-message {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #ff4d4f;
}

.input-with-button {
  display: flex;
  gap: 10px;
}

.send-code-btn {
  padding: 0 16px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.send-code-btn:hover {
  background-color: #359e75;
}

.send-code-btn.is-disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 8px 16px;
  background-color: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-btn:hover {
  background-color: #e5e5e5;
}

.confirm-btn {
  padding: 8px 16px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.confirm-btn:hover {
  background-color: #359e75;
}

.confirm-btn.is-disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.change-password-link {
  position: absolute;
  right: 20px; /* 距离右侧20px */
  bottom: 20px; /* 距离底部20px */
  color: #409eff; /* 使用Element UI的主题蓝色 */
  text-decoration: none;
  font-size: 14px;
}

.change-password-link:hover {
  color: #66b1ff; /* 悬停时的颜色 */
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue